import React from 'react';
import { useTranslation } from 'react-i18next';
import AddRanch from '../ranch-settings/ranches/AddRanch.js';
import './FirstTimeSetup.css';

const FirstTimeSetup = ({ onSuccess }) => {
  const { t } = useTranslation();

  return (
    <div className="FirstTimeSetup">
      <div className="setup-card">
        <p className="setup-card-title">{t('setup_welcome_title')}</p>
        <p className="setup-card-subtitle">{t('setup_welcome_subtitle')}</p>
        <AddRanch onSuccess={onSuccess} />
      </div>
    </div>
  );
};

export default FirstTimeSetup;
